import Section from "@/components/Section";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import ProposeItem from "./components/ProposeItem";
import { options } from "./mockData";

const WhatWeProposeSection = () => {
  const theme = useTheme();
  return (
    <Section pt={2} pb={{ xs: 5, md: 12.5 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: "16px",
            textAlign: { xs: "start", md: "center" },
            width: "100%"
          }}
        >
          The Trackmate Difference
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          sx={{
            color: theme.palette.grey[600],
            maxWidth: "822px",
            textAlign: { xs: "start", md: "center" },
            marginBottom: { xs: "40px", md: "80px" }
          }}
        >
          Our comprehensive suite of services was designed to create a seamless experience from start to finish. Our platform works together synergistically, serving as a one-stop shop for all of your needs in one place. 
        </Typography>
        <Grid container spacing={2}>
          {options.map((opt, index) => (
            <Grid key={index} item xs={12} md={6}>
              <ProposeItem {...opt} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Section>
  );
};

export default WhatWeProposeSection;